// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__2udZi","timerContainer":"Main_timerContainer__2uDM7","howto":"Main_howto__1yBSH","cardImg":"Main_cardImg__3ap4M"};